import * as skinUtils from '../../../utils/skinUtils';
import * as skinActions from '../../skinActions';
import { getLogger } from '../../../services/logger';

const debug = getLogger('actions:skinActions');

export let loadAndApplySkin = customerId => {
  return async dispatch => {
    return skinUtils
      .getCustomerSkin(customerId)
      .then(customerSkin => {
        return dispatch(skinActions.applySkin(customerSkin));
      })
      .catch(error => {
        debug.error('[loadAndApplySkin] Error loading customer skin %s', error);
        let skin = skinUtils.getLastOrDefaultSkin();
        return dispatch(skinActions.applySkin(skin));
      });
  };
};
